import React from 'react'
import useLanguageContext from '../../hooks/useLanguageContext'
import '../../styles/1-Header/Browser.css'

const Browser = () => {

  const languageState = useLanguageContext()

  return (
    <nav id='browser'>
      <ul className='browser__links'>
        <li className='browser__link'><a href='#home'>{ languageState ? "H" : "E" }</a></li>
        <li className='separator'></li>
        <li className='browser__link'><a href='#about'>{ languageState ? "A" : "S" }</a></li>
        <li className='separator'></li>
        <li className='browser__link'><a href='#skills'>{ languageState ? "S" : "H" }</a></li>
        <li className='separator'></li>
        <li className='browser__link'><a href='#portfolio'>P</a></li>
        <li className='separator'></li>
        <li className='browser__link'><a href='#contact'>C</a></li>
      </ul>
    </nav>
  )
}

export default Browser